export default function authenticated({ to, next, store, router }) {
  if (store.state.user.authenticated) {
    if (store.getters['user/hasAccess'](to.path)) return next();
    return router.push({ name: 'noAccess' });
  }

  return router.push({ name: 'user-login' });
}
